import { useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { updateUser } from "../../../redux/slices/userSlice";
import { fetchScheduleTypes } from "../../../redux/slices/scheduleTypeSlice";

const DEFAULT_TYPES = [
  { id: "normal", label: "Normal", workable_days: [1, 2, 3, 4, 5], allows_rest_days: false },
  { id: "shift", label: "Shift work", workable_days: [0, 1, 2, 3, 4, 5, 6], allows_rest_days: true },
];
const TimePlanningTab = ({ currentUser, userId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const configuration = useSelector((state) => state.scheduleTypes.item);
  const isLoading = useSelector((state) => state.scheduleTypes.isLoading);
  const canUpdateUsers = useSelector((state) => state.users?.permissions?.can_update_users === true);
  const [types, setTypes] = useState(DEFAULT_TYPES);
  const [assignedTypeId, setAssignedTypeId] = useState("normal");
  const [savingAssignment, setSavingAssignment] = useState(false);

  useEffect(() => { dispatch(fetchScheduleTypes()); }, [dispatch]);
  useEffect(() => {
    if (configuration?.types?.length) setTypes(configuration.types.map((item) => ({ ...item, workable_days: [...item.workable_days] })));
  }, [configuration]);
  useEffect(() => { setAssignedTypeId(currentUser?.schedule_type || "normal"); }, [currentUser]);

  const saveAssignment = async () => {
    setSavingAssignment(true);
    try { await dispatch(updateUser({ userId, updates: { schedule_type: assignedTypeId } })).unwrap(); }
    finally { setSavingAssignment(false); }
  };

  if (isLoading && !configuration) return <div className="py-5 text-center"><Spinner animation="border" /></div>;

  return <div className="time-planning-tab">
    <div className="atlar-card p-4">
      <h5 className="txt-main fw-bold mb-1">{t("components.TimePlanningTab.employeeSchedule")}</h5><p className="txt-subtle mb-3">{t("components.TimePlanningTab.employeeScheduleDescription")}</p>
      <div className="d-flex align-items-end flex-wrap gap-3"><Form.Group style={{ minWidth: 240 }}><Form.Label>{t("components.TimePlanningTab.scheduleType")}</Form.Label><Form.Select value={assignedTypeId} onChange={(event) => setAssignedTypeId(event.target.value)} disabled={!canUpdateUsers}>{types.map((item) => <option key={item.id} value={item.id}>{item.label}</option>)}</Form.Select></Form.Group>{canUpdateUsers && <Button className="txt-inverse fw-semibold" style={{ backgroundColor: "var(--brand-primary)", borderRadius: "var(--btn-radius)" }} onClick={saveAssignment} disabled={savingAssignment}>{savingAssignment ? <Spinner size="sm" animation="border" /> : t("components.TimePlanningTab.saveAssignment")}</Button>}</div>
    </div>

  </div>;
};

export default TimePlanningTab;
